module.exports = __webpack_public_path__ + "media/images/googleplay-es-2bcdbfca.png";